<template>
  <b-nav-item
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    :to="{ name: 'notification-inbox' }"
  >
    <feather-icon
      :badge="getUnreadNotificationCount()"
      badge-classes="bg-danger"
      class="text-body"
      icon="BellIcon"
      size="21"
    />
  </b-nav-item>
</template>

<script>
import {
  BNavItem,
} from 'bootstrap-vue'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BNavItem,
  },
  methods: {
    getUnreadNotificationCount() {
      const userData = this.getUserData()
      return userData.unread_apply_docs ?? 0
    },
  },
  setup() {
    return {
      getUserData,
    }
  },
}
</script>

<style>

</style>
